"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16WarningTriangleFill = function Svg16WarningTriangleFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.49 13.693l-4.32-8.025-.032-.06c-.201-.372-.411-.763-.615-1.071-.205-.309-.594-.843-1.27-1.154a3 3 0 0 0-2.506 0c-.676.31-1.065.845-1.27 1.154-.204.308-.414.699-.615 1.071l-.032.06-4.32 8.025-.031.057a13.25 13.25 0 0 0-.515 1.022c-.142.333-.354.91-.266 1.603a3 3 0 0 0 1.235 2.068c.568.405 1.177.492 1.537.525.347.032.76.032 1.144.032H16.386c.384 0 .797 0 1.144-.032.36-.033.969-.12 1.537-.525a3 3 0 0 0 1.235-2.068c.088-.693-.124-1.27-.266-1.603-.136-.32-.332-.684-.515-1.022l-.03-.057zM13.04 7.4l-.325 6.5h-1.43l-.325-6.5h2.08zM12 16.63c-.585 0-1.04-.455-1.04-.975s.454-.975 1.04-.975c.585 0 1.04.455 1.04.975s-.455.975-1.04.975z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16WarningTriangleFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16WarningTriangleFill;
exports.default = _default;